import React, { useEffect } from "react";
import Layout from "../components/Layout";
import Container from '@mui/material/Container';
import { useParams } from "react-router"
import { useDispatch, useSelector } from "react-redux";
import { fetchPolicyDetails } from "../redux/actions/policyAction";
import PolicyCard from "../components/PolicyCard";
import PolicyDetails from "../components/PolicyDetails";
import AdditionalInfo from "../components/AdditionalInfo";
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import LoanCard from "../components/LoanCard";
import AssignmentCard from "../components/Assignment";
import PremiumFinancingCard from "../components/PremiumFinancingCard";
import RevivalOption from "../components/RevivalOption";
import Loader from "../components/Loader";
import Graph from "../components/Graph";
import { pathOr } from "ramda";
const Eligibility = () => {
    const { id } = useParams()
    const dispatch = useDispatch();
    const policy = useSelector(state => state.Policy.policyInfo)
    const loading = useSelector(state => state.Loader.loader);
    useEffect(() => {
       dispatch(fetchPolicyDetails({ policyNumber: id }))
    }, [id])
    return (
        <Layout>
            {loading ? (
                <Container maxWidth="sm" style={{ padding: 30, backgroundColor: 'white', borderRadius: 12 }}>
                    <Loader />
                </Container>
            ) : <Container maxWidth="sm" style={{ padding: 30, backgroundColor: 'white', borderRadius: 12 }}>
                <PolicyCard policy={policy} />
                <PolicyDetails policy={policy} />
                <AdditionalInfo policy={policy} />
                {policy.savingType === 'ULIP' && policy.policyStatus !== 'Inforce' && (
                    <Graph policy={policy} />
                )}
                <Paper elevation={3} style={{ paddingTop: 30, paddingBottom: 30, paddingLeft: 24, paddingRight: 24, backgroundColor: '#FAFAFA', borderColor: '#FAFAFA', borderWidth: 1, borderStyle: 'solid', borderRadius: 8, marginTop: 30 }}>
                    <div mb={8}>
                        <Typography color='#4DA235' variant='h5'>Congratulations !</Typography>
                        <Typography variant='caption'>YOUR POLICY ELIGIBLE FOR</Typography>
                    </div>
                    { pathOr(false, ['loanInfo', 'isLoanOnInsuranceEligible'], policy) && (
                        <LoanCard policy={policy} />
                    )}
                    {pathOr(false, ['loanInfo', 'isAssignmentEligible'], policy) && (
                        <AssignmentCard policy={policy} />
                    )}
                    {policy.policyStatus !== 'Inforce' && pathOr(false, ['loanInfo', 'isPremiumFinanceEligible'], policy) && (
                        <PremiumFinancingCard policy={policy} />
                    )}
                    {policy.savingType !== 'ULIP' && policy.policyStatus !== 'Inforce' && (
                    <RevivalOption policy={policy} />
                    )}
                </Paper>
            </Container>}

        </Layout>
    )
}

export default Eligibility